import Content from "../../../../../lib/html5-software-library/src/ranj/eng/content/Content";
import DialogContentComponent from "../../../../../lib/html5-software-library/src/ranj/eng/content/DialogContentComponent";
import DraftEmailContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/DraftEmailContent";
import QuizContentComponent from "../../../../../lib/html5-software-library/src/ranj/eng/content/QuizContentComponent";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import KeyDecisionAnswer from "./KeyDecisionAnswer";
import KeyDecisionDefinition from "./KeyDecisionDefinition";

export default class KeyDecision {
    /**
     * @constructor
     * @param {KeyDecisionDefinition} keyDecisionDefinition 
     * @param {Content} content
     */
    constructor(keyDecisionDefinition, content) {
        this._keyDecisionDefinition = keyDecisionDefinition;
        this._content = content;
        this._optimalAnswers = [];
        this._playerAnswers = [];
    }

    get id() {
        return this._keyDecisionDefinition?.id;
    }

    get chapter() {
        return this._keyDecisionDefinition?.chapter;
    }

    get arc() {
        return this._keyDecisionDefinition?.arc;
    }

    get backgroundImageId() {
        return this._keyDecisionDefinition?.backgroundImageId;
    }

    get prefixAnswers() {
        return this._keyDecisionDefinition?.prefixAnswers;
    }

    get content() {
        return this._content;
    }

    get baseLpKey() {
        return `keyDecisions.${this.id}`;
    }

    get descriptionLpKey() {
        return `${this.baseLpKey}.descriptionText`;
    }

    get feedbackDescriptionLpKey() {
        return `${this.baseLpKey}.feedbackDescriptionText`;
    }

    get actionNeededLpKey() {
        return `${this.baseLpKey}.actionNeededText`;
    }

    /**
     * @returns {Array<KeyDecisionAnswer>}
     */
    get optimalAnswers() {
        return this._optimalAnswers;
    }

    /**
     * @returns {Array<KeyDecisionAnswer>}
     */
    get playerAnswers() {
        return this._playerAnswers;
    }

    set optimalAnswers(value) {
        this._optimalAnswers = value;
    }

    set playerAnswers(value) {
        this._playerAnswers = value;
    }

    /**
     * @param {KeyDecisionAnswer} keyDecision 
     */
    addOptimalAnswer(keyDecisionAnswer) {
        this._optimalAnswers.push(keyDecisionAnswer);
    }

    /**
     * @param {KeyDecisionAnswer} keyDecision 
     */
    addPlayerAnswer(keyDecisionAnswer) {
        this._playerAnswers.push(keyDecisionAnswer);
    }

    toObject() {
        return {
            keyDecisionDefinition: this._keyDecisionDefinition.toObject(),
            content: ContentToObject(this._content),
            optimalAnswers: this._optimalAnswers.map(a => a.toObject()),
            playerAnswers: this._playerAnswers.map(a => a.toObject())
        };
    }

    fromObject(obj, languagePack) {
        this._keyDecisionDefinition = KeyDecisionDefinitionFromObject(obj.keyDecisionDefinition);
        this._content = ContentFromObject(obj.content, languagePack);
        this._optimalAnswers = obj.optimalAnswers.map(a => keyDecisionAnswerFromObject(a));
        this._playerAnswers = obj.playerAnswers.map(a => keyDecisionAnswerFromObject(a));
    }
}

const KeyDecisionDefinitionFromObject = function (obj) {
    const keyDecisionDefinition = new KeyDecisionDefinition();
    keyDecisionDefinition.fromObject(obj);
    return keyDecisionDefinition;
}

const ContentToObject = function (content) {
    let obj = content.convertToObject();
    obj.objType = content.constructor.name;
    return obj;
}

const ContentFromObject = function (obj, languagePack) {
    let content = null;
    switch (obj.objType) {
        case 'DialogContentComponent':
            content = new DialogContentComponent(languagePack, null, null, null, null, null);
            break;
        case 'QuizContentComponent':
            content = new QuizContentComponent(languagePack, null, null, null, null, null);
            break;
        case 'DraftEmailContent':
            content = new DraftEmailContent(languagePack, null, null, null, null, null, null, null, null, null, null, null, null);
            break;
    }
    content.setPropertiesFromObject(obj);
    return content;
}

const keyDecisionAnswerFromObject = function (obj) {
    const keyDecisionAnswer = new KeyDecisionAnswer();
    keyDecisionAnswer.fromObject(obj);
    return keyDecisionAnswer;
}